export const BlockHeaderClasses = () => {
  return {
    base: `pl-4-safe pr-4-safe mt-8 flex items-center -mb-6 text-opacity-55 text-black text-sm`
  };
};